import React, { useCallback, useContext, useEffect, useLayoutEffect, useState } from 'react';
import { Remark } from '../Common/MatchBase';
import NoPoolMsg from '../Common/NoPoolMsg';
import { useTranslation } from 'react-i18next';
import { FootballContext } from '../../Home/FootballPage';
import GPWTable from '../Common/GPWTable';
import SPCTable from '../Common/SPCTable';
import GPFTable from '../Common/GPFTable';
import TQLTable from '../Common/TQLTable';
import GeneralTournTable from '../Common/GeneralTournTable';
import RefreshTime from '../../Common/ui-components/RefreshTime'
import { sortSeq } from '../Common/Common';
import getDistanceOfPageTop from '../../Common/utils/getDistanceOfPageTop';
import { useWindowSize } from '../../Common/CommonHooks';

const Tournament = () => {

    const { t } = useTranslation();
    const context = useContext(FootballContext);
    const { isMobileSize } = useWindowSize()
    const [anchorHash, setAnchorHash] = useState('')
    const tournaments = context.content.tournData?.tournaments || [];
    const AllTournamentOrder = context.content.config.AllTournamentOrder;

    useLayoutEffect(() => {
        if ( window.location.hash!='' ) {
            try{
                let typeStr = window.location.hash.substring(1).toUpperCase()
                setAnchorHash(typeStr)
                setTimeout(() => {
                    let match = document.querySelectorAll('section.Tournament > section')
                    if(isMobileSize) {
                        if([...match].find((el => el.classList.contains(".coupon" + typeStr))))
                            window.scrollTo(0, getDistanceOfPageTop([...match].find((el => el.classList.contains(".coupon" + typeStr)))) - 55)
                        else if([...match].find((el => el.classList.contains(typeStr))))
                            window.scrollTo(0, getDistanceOfPageTop([...match].find((el => el.classList.contains(typeStr)))) - 55)
                    } else {
                        if([...match].find((el => el.classList.contains(".coupon" + typeStr))))
                            [...match].find((el => el.classList.contains(".coupon" + typeStr))).scrollIntoView()
                        else if([...match].find((el => el.classList.contains(typeStr))))
                            [...match].find((el => el.classList.contains(typeStr))).scrollIntoView()
                    }
                }, 1500);
            }catch (err) {
                console.error(err);
                throw err;
            }
        }
    }, [window.location.hash])

    return <Content tournaments={tournaments} AllTournamentOrder={AllTournamentOrder} context={context} anchorHash={anchorHash} />

}
export default Tournament;
const Content = ({tournaments, context, t, AllTournamentOrder, anchorHash}) => {
    return (
        <>
        {context.content.pageConfig.showRefreshTime && <div className='refreshContainer'><RefreshTime product={'football'}/></div>}
            <section className='Tournament'>
                <AllTournamentTable tournaments={tournaments} AllTournamentOrder={AllTournamentOrder} anchorHash={anchorHash} />
            </section>
            <div className='mobileMarginLR'>
                <Remark />
            </div>
        </>
    )

}


const AllTournamentTable = ({tournaments, AllTournamentOrder, anchorHash}) => {

    if (tournaments == null || tournaments.length == 0) {

        return <NoPoolMsg />
    }
    tournaments.sort(sortSeq);
    return tournaments.map((singleTourn) => {
        return AllTournamentOrder.map((oddsType) => {
            let foPools = singleTourn.foPools.filter(x => x.oddsType===oddsType);
            if (foPools.length>0) {
                switch (oddsType) {
                    case "CHP":
                        return <GeneralTournTable isMatch={false} betType="CHP" tourn={singleTourn} isExpand={anchorHash==="CHP"} />
                    case "GPW":
                        return <GPWTable singleTourn={singleTourn} isExpand={anchorHash==="GPW"} />
                    case "GPF":
                        return <GPFTable singleTourn={singleTourn} isExpand={anchorHash==="GPF"} />
                    case "TPS":
                        return <GeneralTournTable isMatch={false} betType="TPS" tourn={singleTourn} isExpand={anchorHash==="TPS"} />
                    case "TSP":
                        return <SPCTable betType="TSP" isMatch={false} tourn={singleTourn} showCoupon={true} isExpand={anchorHash==="TSP"} />;
                    case "TQL":
                        return <TQLTable betType="TQL" isMatch={false} tourn={singleTourn} isExpand={anchorHash==="TQL"} />
                }
            } else {
                return null;
            }
        })

    })
}